import { defineStore } from 'pinia'
import { findById, list, insertFormData, remove, update } from '@/utils/index'
import { getNameAndTypeFile } from '@/utils/image'

const URL = '/v1/library'

export const useLibraryStore = defineStore('library', {
    state: () => ({
        items: [],
    }),

    getters: {
        all: (state) => state.items.map(item => item).sort((a, b) => {
            if(a.created_at > b.created_at){
                return -1;
            } else if(a.created_at < b.created_at){
                return 1;
            }
            return 0;
        }),
        count: (state) => state.items.length,
        getById: (state) => (id) => findById(state.items, id),
        getNameByIds: (state) => (ids = []) =>  state.items.filter((item) => ids.includes(item.id)).map((itemmap) => itemmap.name ),
    },

    actions: {
        /**
         * search all departament
         */
        async fetchItems(type = 'all'){
            return list( this.$state, URL + `?type=${type}`)
        },
        /**
         * search one  departament
         * @param {int} departament
         */
        async fetchItem(id){
            return list( this.$state, URL +'/'+ id)
        },
        /**
         * Add new departament
         * @param {object} departament
         */
        async addItem(item){
            return insertFormData( this.$state, URL, item)
        },

        /**
         * edit departament
         * @param {object, id} departament
         */
        async editItem({ payload, id }) {

            return update( this.$state, URL +'/'+ id, payload)
        },

        /**
         * Remove item from the departament
         * @param {int} id
         */
        async removeItem(id) {
            return remove( this.$state, URL, id)
        },

        async uploadItem(file) {
            const { name, type } = getNameAndTypeFile(file.name)
            if (name === '' && type === 'none') {
                return false
            }
            const payload = new FormData()
            payload.append('action', 'uploadImage')
            payload.append('source', file)
            payload.append('name', name)
            payload.append('origin','library')
            payload.append('recipient','sent')
            payload.append('type', type)
            return await this.addItem(payload)
        },
    },
})